import { useEffect } from "react";

export const useLineBrowserRedirect = () => {
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (/line/.test(ua)) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("openExternalBrowser", "1");
      window.location.href = currentUrl.toString();
    }
  }, []);
};
